/* ------------------------------------------------------------------------------
@name: Hero Banner Mobile
@description: Hero Banner Mobile
--------------------------------------------------------------------------------- */

const HeroBannerMobile = (() => {
  // - handleRunCarousel
  const handleRunCarousel = () => {
    const _selector = $('.js-hero-banner');
    const _itemLength = $('.js-hero-banner .hero-banner__img').length;
    const _itemRun = 1;

    // destroy carousel
    if (_selector.hasClass('owl-carousel')) {
      _selector.owlCarousel('destroy').removeClass('owl-carousel');
    }

    // --- check if itemLength > itemRun
    if (_itemLength > _itemRun) {
      // --- init carousel
      _selector.addClass('owl-carousel').owlCarousel({
        items: 1,
        rewind: true,
        autoplay: true,
        dots: false,
        nav: false,
        loop: true,
        touchDrag: true,
        mouseDrag: true,
        autoplayHoverPause: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplayTimeout: 7000
      });
    } else {
      if (_selector.hasClass('owl-carousel')) {
        _selector.removeClass('owl-carousel');
      }
      _selector.addClass('hero-banner--single');
    }
  };

  // - init
  const init = () => {
    handleRunCarousel();
  };

  return {
    init
  };
})();

export default HeroBannerMobile;
